
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetClose,
} from '@/components/ui/sheet';
import { Home, LayoutDashboard, Music, LogIn, LogOut, MessageCircle } from 'lucide-react';

interface MobileMenuProps {
  isOpen: boolean;
  isAuthenticated: boolean;
  onSignOut: () => void;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  isOpen, 
  isAuthenticated, 
  onSignOut,
  onClose
}) => {
  if (!isOpen) return null;
  
  // Function to scroll to top on navigation
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Combined function for navigation actions
  const handleNavigation = () => {
    scrollToTop();
    onClose();
  };
  
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="p-0 w-full max-w-[85vw] sm:max-w-xs border-l border-border/30">
        <nav className="flex flex-col h-full">
          <div className="flex flex-col space-y-1 px-6 py-8">
            <SheetClose asChild>
              <Link 
                to="/" 
                className="flex items-center py-3 px-2 rounded-md text-foreground hover:bg-accent/50 transition-colors text-sm font-medium"
                onClick={scrollToTop}
              >
                <Home className="mr-3 h-5 w-5 flex-shrink-0" />
                <span>Home</span>
              </Link>
            </SheetClose>
            
            {isAuthenticated && (
              <>
                <SheetClose asChild>
                  <Link 
                    to="/dashboard" 
                    className="flex items-center py-3 px-2 rounded-md text-foreground hover:bg-accent/50 transition-colors text-sm font-medium"
                    onClick={scrollToTop}
                  >
                    <LayoutDashboard className="mr-3 h-5 w-5 flex-shrink-0" />
                    <span>Dashboard</span>
                  </Link>
                </SheetClose>
                
                <SheetClose asChild>
                  <Link 
                    to="/tracks" 
                    className="flex items-center py-3 px-2 rounded-md text-foreground hover:bg-accent/50 transition-colors text-sm font-medium"
                    onClick={scrollToTop}
                  >
                    <Music className="mr-3 h-5 w-5 flex-shrink-0" />
                    <span>Tracks</span>
                  </Link>
                </SheetClose>
              </>
            )}
            
            <SheetClose asChild>
              <Link 
                to="/contact" 
                className="flex items-center py-3 px-2 rounded-md text-foreground hover:bg-accent/50 transition-colors text-sm font-medium"
                onClick={scrollToTop}
              >
                <MessageCircle className="mr-3 h-5 w-5 flex-shrink-0" />
                <span>Contact</span>
              </Link>
            </SheetClose>
          </div>
          
          <div className="mt-auto border-t border-border/30 p-6">
            {isAuthenticated ? (
              <SheetClose asChild>
                <Button 
                  variant="default" 
                  className="w-full justify-center text-sm"
                  onClick={onSignOut}
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  Sign Out
                </Button>
              </SheetClose>
            ) : (
              <div className="flex flex-col space-y-4">
                <SheetClose asChild>
                  <Link 
                    to="/login" 
                    className="flex items-center py-3 px-2 rounded-md text-foreground hover:bg-accent/50 transition-colors text-sm font-medium"
                    onClick={scrollToTop}
                  >
                    <LogIn className="mr-3 h-5 w-5 flex-shrink-0" />
                    <span>Sign In</span>
                  </Link>
                </SheetClose>
                
                <SheetClose asChild>
                  <Link 
                    to="/register" 
                    className="w-full"
                    onClick={scrollToTop}
                  >
                    <Button className="w-full justify-center text-sm">
                      Start My FREE Trial
                    </Button>
                  </Link>
                </SheetClose>
              </div>
            )}
          </div>
        </nav>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
